import styled from '@emotion/styled';

const DeactivatedModelIndicator = styled('span')(({ theme }) => ({
  marginLeft: 12,
  fontSize: 14,
  alignSelf: 'flex-end',
  fontStyle: 'italic',
  color: theme.palette.text.secondary,
}));

export default DeactivatedModelIndicator;
